import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { useCurrentUser } from '@bonusly/who-am-i';

import { Bonus } from '../../../../../../types/bonus';
import { Reaction } from '../../../components/reactions/lib/reaction';
import { RecognizeResponse } from '../../../types/api';
import { useAddReactionToBonus } from './use-add-reaction-to-bonus';
import { useRemoveReactionFromBonus } from './use-remove-reaction-from-bonus';
import { useReplaceBonus } from './use-replace-bonus';

export const useRemoveReaction = (bonus: Bonus) => {
	const user = useCurrentUser();
	const addReaction = useAddReactionToBonus();
	const removeReaction = useRemoveReactionFromBonus();
	const replaceBonus = useReplaceBonus();
	const http = useHttpClient('v2');
	const queryClient = useQueryClient();
	return useMutation(
		(reaction: Reaction) => {
			return http.delete<RecognizeResponse<Bonus>>(`reactions/${reaction.id}`, {
				params: {
					bonus_id: bonus.id,
					emoji: reaction.shortcode,
				},
			});
		},
		{
			onMutate: ({ type }) => {
				const reaction = bonus.reactions?.find((r) => r.user_id === user.id && Reaction.fromShortcode(r.emoji).type === type);

				if (reaction) {
					removeReaction(bonus.id, reaction._id);
				}

				return reaction;
			},
			onError: (_err, _type, reaction) => {
				if (reaction) {
					addReaction(bonus.id, reaction);
				}
			},
			onSuccess: (data) => {
				replaceBonus(data.data.result);
				queryClient.invalidateQueries(['reactions', bonus.id]);
			},
		}
	);
};
